import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiHook } from "../../hooks/apiHook";
import PartyTableMain from "../../components/Party/PartyTableMain";

const HostManagement = () => {
    const { t } = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const hostDetails = ApiHook.CallGetPartyHosts(itemsPerPage, currentPage);
    return (
        <>
            <div className="page_head_top">{t("hostManagement")}</div>
            <PartyTableMain
                type="hosts"
                filterButtonPath="/add-host"
                filterButtonText="addhost"
                tableData={hostDetails?.data}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />
        </>
    )
};

export default HostManagement;